
export const PublicSellerFabricsQuery = new TypedDocumentString(`
    query PublicSellerFabricsQuery($sellerId: ObjectId!) {
  publicSellerFabrics(sellerId: $sellerId) {
    ...ProductExtraFabric
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductExtraCare on ProductExtraCare {
  message {
    value
    __typename
  }
  _careIcons {
    ...ProductExtraCareIcon
    __typename
  }
  __typename
}
fragment ProductExtraCareIcon on ProductExtraCareIcon {
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  __typename
}
fragment ProductExtraFabric on ProductExtraFabric {
  title {
    value
    __typename
  }
  description {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  _care {
    ...ProductExtraCare
    __typename
  }
  __typename
}`, {"hash":"42638e8294b6eecf1ae7dbdb534ad13d54b533fdb9a5843468aaf37621c107de"});